module.exports = __webpack_public_path__ + "img/text-rechnung.3f842ca6.png";